import { render } from "./DownloadData.vue?vue&type=template&id=d78eeacc&scoped=true&bindings={\"msg\":\"props\",\"isLoading\":\"data\",\"sleep\":\"options\",\"screenShot\":\"options\",\"fileDownload\":\"options\"}"
import script from "./DownloadData.vue?vue&type=script&lang=js"
export * from "./DownloadData.vue?vue&type=script&lang=js"

import "./DownloadData.vue?vue&type=style&index=0&id=d78eeacc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d78eeacc"

export default script